<template>
  <div>    
    <b-row :class="[{'block-product-add':crud.form.detail_register.editing}]">
      <b-col lg="4">
        <b-row>
          <b-col lg="12" md="12">
            <FindObject :key="'products-' + crud.form.detail_register.forceRenderSelectProduct"
                        render="search"
                        type="products" 
                        @select-object="loadProducts($event)" 
                        :valueID="crud.form.detail_register.product_id"
                        :where="conditionProductsActive" /> 
          </b-col>
          <b-col lg="12" md="12">                          
            <div v-if="!haveOnlyProduct">
              <div v-if="haveColorsWaist">
                <!-- COLOR Y TALLE --> 
                <b-row>
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_color.length>0">
                    <b-form-group label="Color">
                      <v-select :options="crud.form.detail_register.opt_color" 
                                v-model="crud.form.detail_register.color" 
                                placeholder="Color" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectColorCombinado"></v-select>
                    </b-form-group>
                  </b-col>                            
                  <b-col lg="6" md="6" v-if="crud.form.detail_register.opt_waist.length>0">
                    <b-form-group label="Talle">                                
                      <v-select :options="crud.form.detail_register.opt_waist" 
                                v-model="crud.form.detail_register.waist" 
                                placeholder="Talle" 
                                :multiple="false" 
                                :select-on-tab="true"
                                @input="selectWaistCombinado"></v-select>                      
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <!-- COLOR -->
                <div v-if="haveOnlyColors">
                  <b-row>
                    <b-col lg="6" md="6">
                      <b-form-group label="Color">
                        <v-select :options="crud.form.detail_register.opt_color" 
                                  v-model="crud.form.detail_register.color" 
                                  placeholder="Color" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectColorSimple"></v-select>
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>

                <!-- TALLE -->
                <div v-if="haveOnlyWaist">
                  <b-row>
                    <b-col lg="6" md="6">                                
                      <b-form-group label="Talle">
                        <v-select :options="crud.form.detail_register.opt_waist" 
                                  v-model="crud.form.detail_register.waist" 
                                  placeholder="Talle" 
                                  :multiple="false" 
                                  :select-on-tab="true"
                                  @input="selectWaistSimple"></v-select>                      
                      </b-form-group>                              
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>                          
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="8">
        <b-row v-if="crud.form.detail_register.unit_measurement">
          
          <b-col lg="3">
            <b-form-group label="Cantidad">
              <b-input-group size="sm">
                <b-form-input v-model="crud.form.detail_register.quantity" 
                              type="number" 
                              min="0" 
                              step="1.0000" 
                              class="form-control" />        
                              
                <template #append>                  
                  <b-dropdown :text="crud.form.detail_register.unit_measurement.reference" 
                              :title="crud.form.detail_register.unit_measurement.name" 
                              variant="secondary"
                              v-if="Object.keys(arr.equivalences).length">
                    <b-dropdown-item v-for="element in arr.equivalences" 
                                    :key="element.id" 
                                    @click="setUnitMeasurementAlternative(element)">
                      {{element.name}} ({{element.reference}})
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-button v-else size="sm" variant="secondary" :text="crud.form.detail_register.unit_measurement.reference">
                    {{crud.form.detail_register.unit_measurement.reference}} 
                  </b-button>
                </template>                                       
              </b-input-group>
            </b-form-group>
          </b-col> 
          <b-col lg="4" v-if="this.crud.form.detail_register.selectedProduct">          
            <FindObject :key="'deposits-locations-origin-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Origen"
                        render="search"
                        type="deposits-location" 
                        display="full_reference" 
                        @select-object="loadLocations($event)" 
                        :valueID="crud.form.detail_register.location_id"
                        :where="conditionLocationActive"
                        :orWhere="conditionLocationActiveOR" 
                        :showAllRegister="this.crud.form.detail_register.selectedProduct.depositLocationDetail.length>0"/>             
          </b-col>
          <b-col lg="4">          
            <FindObject :key="'deposits-locations-destination-' + crud.form.detail_register.forceRenderSelectProduct"
                        tag="Ubicación Destino"
                        render="search"
                        type="deposits-location" 
                        display="full_reference"
                        @select-object="loadLocationsDestination($event)" 
                        :valueID="crud.form.detail_register.location_destination_id"
                        :where="conditionLocationActive" 
                        v-if="operation.reference == 'transferencia'"
                        :showAllRegister="false"/>             
          </b-col>
          <b-col lg="1" class="crud-new-orders-button-add">
            <b-button @click="addItem()" 
                      v-b-tooltip.hover 
                      :variant="crud.form.detail_register.button.variant"
                      :title="crud.form.detail_register.button.title"
                      size="sm">
              <i :class="crud.form.detail_register.button.icon"></i>
            </b-button>
          </b-col>

        </b-row>
      </b-col>

      <b-col lg="12" v-if="crud.form.detail_register.editing" class="block-product-add-div">
        <b-icon icon="circle-fill" animation="throb" font-scale="2"></b-icon>
      </b-col>      
    </b-row>
    <b-row class="mt-3">
      <b-col md="12">                  
        <b-table :key="'table_product_' + forceUpdate"
          class="mb-0 crud-order-table-detail"
          responsive="sm"
          head-variant="dark"
          :hover="true"
          :small="true"
          :fixed="false"
          :items="crud.form.detail"
          :fields="visibleTableDetailNewOrder">
          
          <template v-slot:cell(code)="data">  
            <div v-if="data.item.product">
              {{data.item.product.code}}
            </div>
          </template>  

          <template v-slot:cell(product)="data">  
            <div v-if="data.item.product">
              {{data.item.product.name}}
              <span v-if="data.item.product.color">                                                        
                - <i>{{data.item.product.color.name}}</i>
              </span>
                                      
              <span v-if="data.item.product.waist && data.item.product.waist.name">
                - <i>{{data.item.product.waist.name}}</i>
              </span>     
            </div>
          </template>   

          <template v-slot:cell(quantity)="data">                            
            {{ parseFloat(data.item.quantity).toFixed(4) }} 
            <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
          </template>   

          <template v-slot:cell(price_cost)="data">
            <product-price-cell v-if="allowPurchasePricing && isSimpleProductItem(data.item)"
                                :item="data.item"
                                :supplier-id="operation ? (operation.suppliers_id || 0) : 0"
                                :currency="currency"
                                edit-source="purchaseRemits" />
            <span v-else>{{ formatCurrency(data.item.price_cost || 0) }}</span>
          </template>
          
          <template v-slot:cell(deposit)="data">                          
            <span v-if="data.item.location && data.item.location.zone && data.item.location.zone.deposit">
              {{data.item.location.zone.deposit.reference}} /
              {{data.item.location.zone.reference}} /
              {{data.item.location.reference}}
            </span>
          </template>  

          <template v-slot:cell(deposit_destination)="data">                          
            <span v-if="data.item.location_destination && data.item.location_destination.zone && data.item.location_destination.zone.deposit">
              {{data.item.location_destination.zone.deposit.reference}} /
              {{data.item.location_destination.zone.reference}} /
              {{data.item.location_destination.reference}}
            </span>
          </template>            

          <template v-slot:cell(f_action)="data">  
            <b-dropdown right 
                        text="" 
                        size="sm" 
                        variant="outline-dark"  
                        :disabled="crud.form.detail_register.button.editing">                      
              <b-dropdown-item @click="editItem(data.item, data.index)">
                <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="deleteItem(data.index)" style="color:red;">
                <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
              </b-dropdown-item>     
            </b-dropdown>                                
          </template>                    
        </b-table>                  
      </b-col>
    </b-row>
    <b-alert v-if="p79AlertVisible" show variant="info" class="mt-2 mb-0 p79-alert">
      <b-icon icon="info-circle" class="mr-2"></b-icon>
      Al guardar este remito, <strong>{{ operation && operation.supplier ? operation.supplier.name : 'el proveedor' }}</strong>
      quedará como proveedor principal para los productos que tenga vinculados en costos.
    </b-alert>
  </div>       
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'    
  import Param from '@/config/parameters'
  import moment from 'moment'
  import ProductPriceCell, { pricingCache } from '@/components/inc/productPricing/productPriceCell'
  import costsServiceAPI from '@/components/inc/productPricing/services'

  export default {
    props: {     
      operation: {
        type: [Object, Array],
        default: [],        
      },      
      detailEdit: {
        type: [Array, Object],
        default: null,
      },
      allowPurchasePricing: {
        type: Boolean,
        default: false,
      },
      currency: {
        type: String,
        default: 'ARS',
      },
      forceUpdate: {
        type: Number,
        default: 0,
      },          
    },
    components: {
      FindObject,
      ProductPriceCell,
    },
    data: () => {
      return {  
        tableDetailNewOrder : [],           
        crud: {
          form: {
            detail_register: {
              opt_color: [],
              opt_waist: [],
              color: null,
              waist: null,
              quantity: 0,
              quantityOld: 0,      
              product_id: 0,
              product: null,              
              selectedProduct: null,
              selectProduct: null,
              forceRenderSelectProduct: 0,                                   
              unit_measurement: null,
              unit_measurement_id: 0,
              price_cost: 0,
              location: null,
              location_id: 0,
              location_destination: null,
              location_destination_id: 0,   
              purchase_orders_id: 0,
              purchase_orders_detail_id: 0,
              button: {
                icon: 'fa fa-plus',
                title: 'Agreagr Item',
                variant: 'success',
                editing: false
              },                    
              editing: false,     
            },            
            detail: [],                 
          },          
        },    
        arr: {
          equivalences: [],            
        }        
      }
    },
    computed: {
      // CONDITIONS SELECT
      conditionProductsActive() {
        return [{field: 'm_products.active', condition: true}];
      },
      conditionLocationActive() {        
        var conditional = []
        conditional.push({field: 'active', condition: true})
        return conditional        
      },
      conditionLocationActiveOR() {        
        var conditional = []
                
        if(this.operation.reference == 'sub-manual' || this.operation.reference == 'transferencia') {
          if(this.crud.form.detail_register.selectedProduct) {
            if(this.crud.form.detail_register.selectedProduct.depositLocationDetail) {
              this.crud.form.detail_register.selectedProduct.depositLocationDetail.forEach(element => {
                if(element.quantity>0) {
                  conditional.push({field: 'id', condition: element.location_id})
                }              
              });
            }
          }
        }

        if(!conditional.length) {          
          if(this.operation.type && this.operation.type.type_balance == '+')
            conditional = [];
          else 
            conditional.push({field: 'id', condition: -1})                
        }        
        
        return conditional
      },      
      getDetailRegisterSupplierProduct() {
        if(!this.crud.form.detail_register.selectedProduct) {
          return null
        }

        if(this.crud.form.detail_register.selectedProduct.source != 'product') {
          return null
        }

        if(this.crud.form.detail_register.selectedProduct.product_purchase) {
          return this.crud.form.detail_register.selectedProduct.product_purchase
        }

        if(this.crud.form.detail_register.selectedProduct.product &&
           this.crud.form.detail_register.selectedProduct.product.product_purchase) {
          return this.crud.form.detail_register.selectedProduct.product.product_purchase
        }

        return null
      },
      isSimpleSelectedProduct() {
        return !!(
          this.crud.form.detail_register.selectedProduct &&
          this.crud.form.detail_register.selectedProduct.source == 'product'
        )
      },
      visibleTableDetailNewOrder() {
        if(this.shouldShowPurchasePricingColumn) {
          return this.tableDetailNewOrder
        }

        return this.tableDetailNewOrder.filter((field) => field.key != 'price_cost')
      },
      shouldShowPurchasePricingColumn() {
        if(!this.allowPurchasePricing) {
          return false
        }

        if(this.isSimpleSelectedProduct) {
          return true
        }

        return this.crud.form.detail.some((item) => this.isSimpleProductItem(item))
      },
      p79AlertVisible() {
        if(!this.allowPurchasePricing) return false
        if(!this.crud.form.detail.length) return false
        if(!this.operation || !this.operation.suppliers_id) return false
        return Helper.hasParametersAccess(Param.P79)
      },      

      // CONFIGURACION DE PRODUCTO - VARIEDAD
      haveColorsWaist() {
        if(this.crud.form.detail_register.product) {
          if(this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyColors() {     
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyWaist() {
        if(this.crud.form.detail_register.product) { 
          if( this.crud.form.detail_register.product.waist.length && 
              !this.crud.form.detail_register.product.colors.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      haveOnlyProduct() {
        if(this.crud.form.detail_register.product) { 
          if( !this.crud.form.detail_register.product.colors.length && 
              !this.crud.form.detail_register.product.waist.length &&
              !this.crud.form.detail_register.product.colors_waist.length) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },  

      // GET COLOR
      getColorWaistUnique() {        
        var arrColorsWaist = []         
        var arrColorsWaistTMP = []                  
        if(this.crud.form.detail_register.product) {          
          this.crud.form.detail_register.product.colors_waist.forEach(element => {
            if(!arrColorsWaistTMP.includes(element.color.id)) {
              arrColorsWaist.push(element)
              arrColorsWaistTMP.push(element.color.id)
            }          
          });       
          return arrColorsWaist
        }       
      },
      getWaistByColor() {                
        var waist = []        
        if(this.crud.form.detail_register.color) {
          if(this.crud.form.detail_register.color.code) {            
            this.crud.form.detail_register.product.colors_waist.forEach(element => {                        
              if(element.color.id == this.crud.form.detail_register.color.code.id) {              
                waist.push(element)
              }
            });
          }
        }
        return waist
      },               
    },
    watch: {
      'operation.suppliers_id'(newVal, oldVal) {
        if(oldVal && newVal !== oldVal && this.allowPurchasePricing) {
          this.crud.form.detail = []
          this.$emit('load-detail', [])
        }
      },
    },
    mounted() {
      this.configFieldsTable()
      this.loadItems()
    },
    methods: {
      configFieldsTable() {
        this.tableDetailNewOrder.push({key: 'code', label: 'Código', class:"align-middle"})              
        this.tableDetailNewOrder.push({key: 'product', label: 'Producto', class:"align-middle"})              
        this.tableDetailNewOrder.push({key: 'quantity', label: 'Cantidad', class:"align-middle text-center"})                
        if(this.allowPurchasePricing) {
          this.tableDetailNewOrder.push({key: 'price_cost', label: 'Precio compra', class:"align-middle text-right"})
        }
        this.tableDetailNewOrder.push({key: 'deposit', label: 'Ubicación (Origen)', class:"align-middle text-right"})                

        if(this.operation.reference == 'transferencia') {
          this.tableDetailNewOrder.push({key: 'deposit_destination', label: 'Ubicación (Destino)', class:"align-middle text-left"})  
        }
        
        this.tableDetailNewOrder.push({key: 'f_action', label:'', class:"align-middle text-right"})
      },
      loadItems() {              
        if(this.detailEdit) {
          this.detailEdit.forEach(element => {            
            var arrItem = {
              product: element.product,
              quantity: parseFloat(element.quantity),
              quantityOld: parseFloat(element.quantity),
              unit_measurement: element.unit_measurement,
              location: element.location,
              location_destination: element.location_destination,
              purchase_orders_id: element.purchase_orders_id || 0,
              purchase_orders_detail_id: element.purchase_orders_detail_id || 0,
            }
            this.applyPurchasePricingToItem(arrItem, element)

            this.crud.form.detail.push(arrItem)

            // Para ítems de OC: hidratar inmediatamente para obtener el precio del proveedor actual
            if(element.purchase_orders_detail_id) {
              this.hydrateItemPricingFromCosts(arrItem)
            }
          });

          this.$emit('load-detail', this.crud.form.detail)
        }
      },      
      loadProducts (object) {
        if(object){
          this.crud.form.detail_register.product = object
          this.crud.form.detail_register.product_id = object.id     
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null
          
          this.crud.form.detail_register.amount = 0
          this.crud.form.detail_register.currency = null 
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []
          this.crud.form.detail_register.forceRenderSelectProduct = object.id
          this.crud.form.detail_register.selectedProduct = null   
          this.crud.form.detail_register.selectProduct = null
          this.crud.form.detail_register.unit_measurement = object.unit_measurement_purchase_default
          this.crud.form.detail_register.unit_measurement_id = object.unit_measurement_purchase_default.id                    
                              
          if(object.colors_waist.length) {
            var colorUnique = this.getColorWaistUnique          
            if(colorUnique) {
              colorUnique.forEach(element => {
                this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})
              });
            }
            return false 
          } 
          
          if(object.colors.length) {
            var detail_register = []
            var colorUnique = object.colors          
                        
            if(colorUnique) {              
              colorUnique.forEach(element => {                  
                this.crud.form.detail_register.opt_color.push({code: element.color, label: element.color.name})                
              });              
            }    
            return false                              
          }

          if(object.waist.length) {
            var detail_register = []
            var waistUnique = object.waist

            if(waistUnique) {
              waistUnique.forEach(element => {                  
                this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
              });
            }
            return false
          }    
          
          if(!object.colors_waist.length && !object.colors.length && !object.waist.length) {            
            this.selectedProduct()                  
          }

          this.loadEquivalences() 

        } else {                    
          this.crud.form.detail_register.product_id = 0                  
          this.crud.form.detail_register.product = null
          
          this.crud.form.detail_register.color = null
          this.crud.form.detail_register.waist = null              
          this.crud.form.detail_register.quantity = 0          
          this.crud.form.detail_register.opt_color = []
          this.crud.form.detail_register.opt_waist = []   
          this.crud.form.detail_register.selectedProduct = null
          this.crud.form.detail_register.selectProduct = null
          this.crud.form.detail_register.unit_measurement = null
          this.crud.form.detail_register.unit_measurement_id = 0
          this.crud.form.detail_register.price_cost = 0
          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0      
          this.crud.form.detail_register.purchase_orders_id = 0
          this.crud.form.detail_register.purchase_orders_detail_id = 0
          
          this.crud.form.detail_register.button.title = "Agregar Item"
          this.crud.form.detail_register.button.icon = "fa fa-plus"
          this.crud.form.detail_register.button.variant = "success"            
        }
      },    
      loadLocations (object) {        
        if(object){
          this.crud.form.detail_register.location = object
          this.crud.form.detail_register.location_id = object.id

          this.showAlertLocationsWithProductsDifferent(object)
        } else {
          this.crud.form.detail_register.location = null
          this.crud.form.detail_register.location_id = 0
        }
      },
      loadLocationsDestination (object) {
        if(object){
          this.crud.form.detail_register.location_destination = object
          this.crud.form.detail_register.location_destination_id = object.id

          this.showAlertLocationsWithProductsDifferent(object, true)
        } else {
          this.crud.form.detail_register.location_destination = null
          this.crud.form.detail_register.location_destination_id = 0
        }
      },

      // ALERT LOCATIONS
      showAlertLocationsWithProductsDifferent(location, showAlert=false) {
        if(this.operation.reference == 'add-manual' || this.operation.selectTypeVoucher == 'remito' || showAlert) {
          var show = false
          if(this.crud.form.detail_register.selectedProduct) {
            var source = this.crud.form.detail_register.selectedProduct.source
            var id = this.crud.form.detail_register.selectedProduct.id
            
            if(location.contains) {
              location.contains.forEach(element => {
                if(!(element['source'] == source && element['id'] == id)) {
                  show = true
                }
              });
            }
          }        
          if(show) {
            this.$awn.info("La ubicación seleccionada se encuentra ocupada por un producto diferente al seleccionado")
          }
        }
      },

      // SELECCION PRODUCTO-VARIEDAD 
      selectColorCombinado(item) {        
        this.crud.form.detail_register.color = item
        this.crud.form.detail_register.waist = null

        this.crud.form.detail_register.opt_waist = []
        var waistUnique = this.getWaistByColor          
        if(waistUnique) {
          waistUnique.forEach(element => {
            this.crud.form.detail_register.opt_waist.push({code: element.waist, label: element.waist.name})
          });
        }         
      },
      selectWaistCombinado(item) {
        this.crud.form.detail_register.waist = item
        this.selectedProduct()        
      },      
      selectColorSimple(item) {
        this.crud.form.detail_register.color = item
        this.selectedProduct()        
      },
      selectWaistSimple(item) {
        this.crud.form.detail_register.waist = item      
        this.selectedProduct()        
      },  

      // PRODUCTO/VARIEDAD SELCCIONADA
      selectedProduct() {        
        var variantSelect = null

        if(this.crud.form.detail_register.product) {
          if(this.haveOnlyProduct) {
            variantSelect = this.crud.form.detail_register.product
            variantSelect['source'] = 'product'
          } else {
            if(this.haveColorsWaist) {
              if(this.crud.form.detail_register.color && this.crud.form.detail_register.waist) {
                this.crud.form.detail_register.product.colors_waist.forEach(element => {                
                  if( element.colors_id == this.crud.form.detail_register.color.code.id && 
                      element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                      variantSelect = element                      
                      variantSelect['source'] = 'colors_waist'
                  }
                });
              }            
            } else {
              if(this.haveOnlyColors) {                
                if(this.crud.form.detail_register.color) {                  
                  this.crud.form.detail_register.product.colors.forEach(element => {                                       
                    if( element.colors_id == this.crud.form.detail_register.color.code.id ) {                                      
                        variantSelect = element                        
                        variantSelect['source'] = 'colors'
                    }
                  })
                }
              } else {
                if(this.haveOnlyWaist) {
                  if(this.crud.form.detail_register.waist) {
                    this.crud.form.detail_register.product.waist.forEach(element => {                   
                      if( element.waist_id == this.crud.form.detail_register.waist.code.id ) {                                      
                          variantSelect = element                          
                          variantSelect['source'] = 'waist'
                      }
                    })
                  }
                }            
              }          
            }     
          }             
        }

        if(variantSelect) {                    
          this.crud.form.detail_register.selectedProduct = variantSelect
        } else {                      
          this.crud.form.detail_register.selectedProduct = null
        }    

        this.crud.form.detail_register.selectProduct = this.getBaseProductForRow(this.crud.form.detail_register.selectedProduct)
        this.syncDetailRegisterPurchasePriceDefaults()
      }, 
      
      // ABM MAIN DETAILS
      addItem() {        
        // producto
        if(!this.crud.form.detail_register.selectedProduct) {
          this.$awn.alert('No se seleccionó el producto')          
          return false
        }

        // cantidad
        if (this.crud.form.detail_register.quantity.toString() == '' || parseFloat(this.crud.form.detail_register.quantity)<=0) {
          this.$awn.alert('La cantidad debe ser mayor a cero')          
          return false
        }
                      
        // deposito/zona/ubicacion Origen
        if (!this.crud.form.detail_register.location) {
          this.$awn.alert('Falta seleccionar la ubicación')          
          return false
        }      
        
        // deposito/zona/ubicacion Destino
        if(this.operation.reference == 'transferencia') {
          if (!this.crud.form.detail_register.location_destination) {
            this.$awn.alert('Falta seleccionar la ubicación destino')          
            return false
          }              
        }
        
        // ubicación en transferencia
        if(!this.validDepositLocation()) {
          this.$awn.alert('La ubicación en depósito de salida no puede ser la misma que la ubicación de entrada') 
          return false          
        }

        // duplicados
        if(!this.validDuplicatedItem()) {
          this.$awn.alert('Item Duplicado') 
          return false          
        }

        let jsonLocation = JSON.stringify(this.crud.form.detail_register.location);
        let newJsonLocation = JSON.parse(jsonLocation, (key, value) => {
          if (key === 'contains') return undefined; 
          return value;
        });

        let jsonLocationDestination = JSON.stringify(this.crud.form.detail_register.location_destination);
        let newJsonLocationDestination = JSON.parse(jsonLocationDestination, (key, value) => {
          if (key === 'contains') return undefined; 
          return value;
        });        

        var arrItem = { 
          product: this.crud.form.detail_register.selectedProduct,
          quantity: parseFloat(this.crud.form.detail_register.quantity),
          quantityOld: parseFloat(this.crud.form.detail_register.quantityOld),          
          unit_measurement: this.crud.form.detail_register.unit_measurement,          
          location: newJsonLocation,
          location_destination: newJsonLocationDestination,
          purchase_orders_id: this.crud.form.detail_register.purchase_orders_id || 0,
          purchase_orders_detail_id: this.crud.form.detail_register.purchase_orders_detail_id || 0,
        }
        this.applyPurchasePricingToItem(arrItem, {
          price_cost: this.crud.form.detail_register.price_cost,
          selectProduct: this.crud.form.detail_register.selectProduct,
        })

        this.crud.form.detail.push(arrItem)
        this.$emit('load-detail', this.crud.form.detail)
        this.hydrateItemPricingFromCosts(arrItem)

        this.crud.form.detail_register.forceRenderSelectProduct = 0
        this.loadProducts(null)    
        
        this.crud.form.detail_register.button.editing = false
      },
      editItem (item, index) {    
        this.crud.form.detail_register.editing = true        
        this.crud.form.detail_register.quantity = item.quantity
        this.crud.form.detail_register.quantityOld = item.quantityOld        
        this.crud.form.detail_register.location = item.location
        this.crud.form.detail_register.location_id = item.location.id
        if(this.isSimpleProductItem(item)) {
          this.crud.form.detail_register.price_cost = parseFloat(item.price_cost || 0)
          this.crud.form.detail_register.selectProduct = item.selectProduct || this.getBaseProductForRow(item.product)
        } else {
          this.crud.form.detail_register.price_cost = 0
          this.crud.form.detail_register.selectProduct = null
        }
        this.crud.form.detail_register.purchase_orders_id = item.purchase_orders_id || 0
        this.crud.form.detail_register.purchase_orders_detail_id = item.purchase_orders_detail_id || 0
        
        if(item.location_destination) {
          this.crud.form.detail_register.location_destination = item.location_destination
          this.crud.form.detail_register.location_destination_id = item.location_destination.id        
        }
                                   
        if(item.product.source == 'product') {             
          this.crud.form.detail_register.product_id = item.product.id
          this.crud.form.detail_register.forceRenderSelectProduct = item.product.id      
          
          this.crud.form.detail_register.editing = false
        } else {          
          if(item.product.source == 'colors_waist') {
            this.crud.form.detail_register.product_id = item.product.products_id      
            this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
            
            setTimeout(()=>{
              this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
              this.selectColorCombinado(this.crud.form.detail_register.color)

              setTimeout(()=>{
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistCombinado(this.crud.form.detail_register.waist)         
                
                this.crud.form.detail_register.editing = false
              },1000)              
            },1000)                        
          } else {
            if(item.product.source == 'colors') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
                                          
              setTimeout(()=>{                
                this.crud.form.detail_register.color = {code:item.product.color, label:item.product.color.name}
                this.selectColorSimple(this.crud.form.detail_register.color)        
                
                this.crud.form.detail_register.editing = false
              },1000)                            
            }
            if(item.product.source == 'waist') {
              this.crud.form.detail_register.product_id = item.product.products_id
              this.crud.form.detail_register.forceRenderSelectProduct = item.product.products_id
              
              setTimeout(()=>{                
                this.crud.form.detail_register.waist = {code:item.product.waist, label:item.product.waist.name}                
                this.selectWaistSimple(this.crud.form.detail_register.waist)     
                
                this.crud.form.detail_register.editing = false
              },1000)                            
            }
          }
        }

        setTimeout(()=>{
          this.crud.form.detail_register.unit_measurement = item.unit_measurement
          this.crud.form.detail_register.unit_measurement_id = item.unit_measurement.id           
        },500)

        this.crud.form.detail_register.button.title = "Editar Item"
        this.crud.form.detail_register.button.icon = "fa fa-save"
        this.crud.form.detail_register.button.variant = "warning"
        this.crud.form.detail_register.button.editing = true        
                             
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      deleteItem (index) {
        this.crud.form.detail.splice(index, 1)
        this.$emit('load-detail', this.crud.form.detail)
      },
      
      // VALID DUPLICATED
      validDuplicatedItem() {
        var item = this.crud.form.detail_register.selectedProduct
        var location_id = this.crud.form.detail_register.location_id
        var status = true
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {                                    
            if(element.product.source=='product') {
              if(element.product.id == item.id && element.location.id == location_id) {
                status = false
              }              
            } 
            
            if(element.product.source=='colors_waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && element.location.id == location_id) {
                status = false
              }              
            }

            if(element.product.source=='colors') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && element.location.id == location_id) {
                   status = false
                 }              
            }

            if(element.product.source=='waist') {
              if(element.product.id == item.id &&
                 element.product.products_id == item.products_id && element.location.id == location_id) {              
                  status = false
              }              
            }
          });
        }
        return status
      },
      
      // VALID DEPOSIT / UBICACION EN TRANSFERENCIA
      validDepositLocation() {
        var status = true
        var value = this.crud.form.detail_register

        if(this.operation.reference == 'transferencia') {
          if(parseFloat(value.location_id) == parseFloat(value.location_destination_id)) {
            status = false
          }
        }
        
        return status
      }, 
      
      // LOAD EQUIVALENCES
      loadEquivalences() {        
        this.arr.equivalences = []

        if(this.crud.form.detail_register.selectedProduct) {                  
          var result = serviceAPI.obtenerEquivalencesAvailable({
            unit_measurement_id: this.crud.form.detail_register.selectedProduct.unit_measurement_purchase_default.id,
          })

          result.then((response) => {
            var data = response.data
            this.arr.equivalences = data
          })      
        }
      }, 
      setUnitMeasurementAlternative(element) {                
        this.crud.form.detail_register.unit_measurement = element
        this.crud.form.detail_register.unit_measurement_id = element.id                   
      },            
      getBaseProductForRow(item) {
        if(!item) {
          return null
        }

        if(item.source == 'product') {
          return item
        }

        return null
      },
      isSimpleProductItem(item) {
        return !!(item && item.product && item.product.source == 'product')
      },
      applyPurchasePricingToItem(item, source={}) {
        if(this.allowPurchasePricing && this.isSimpleProductItem(item)) {
          item.selectProduct = source.selectProduct || this.getBaseProductForRow(item.product)
          var pp = item.selectProduct ? item.selectProduct.product_purchase : null
          var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0

          // Si el product_purchase es de otro proveedor, no usarlo
          if(pp && supplierId && pp.suppliers_id && pp.suppliers_id != supplierId) {
            pp = null
            if(item.selectProduct) this.$set(item.selectProduct, 'product_purchase', null)
          }

          var defaultPrice = pp ? parseFloat(pp.price_list || pp.price_cost || 0) : 0

          // Para ítems de OC no usar el precio de la OC — el precio correcto viene del
          // módulo de costos para este proveedor (se actualiza al hidratar)
          var storedPrice = source.purchase_orders_detail_id ? 0 : parseFloat(source.price_cost || 0)
          item.price_cost = storedPrice || defaultPrice
          return item
        }

        item.price_cost = 0
        item.selectProduct = null
        return item
      },
      hydrateItemPricingFromCosts(item) {
        if(!this.allowPurchasePricing || !this.isSimpleProductItem(item)) return
        var product = item.selectProduct || this.getBaseProductForRow(item.product)
        var productId = product ? product.id : 0
        if(!productId) return
        var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0
        var cacheKey = productId + ':' + supplierId
        var cached = pricingCache[cacheKey]
        if(cached) {
          var items = Array.isArray(cached.suppliers_products) ? cached.suppliers_products : []
          var sp = supplierId ? items.find(r => r.suppliers_id == supplierId) : items.find(r => r.default) || items[0]
          if(sp) {
            var cost = parseFloat(sp.price_cost || sp.price_list || 0)
            if(cost) this.$set(item, 'price_cost', cost)
            this.$set(item, '_supplierNotLinked', false)
          } else if(supplierId) {
            this.$set(item, '_supplierNotLinked', true)
          }
          return
        }
        costsServiceAPI.cargarProductoCostosPorId({ product_id: productId })
          .then(response => {
            var data = response.data || {}
            pricingCache[cacheKey] = data
            var list = Array.isArray(data.suppliers_products) ? data.suppliers_products : []
            var match = supplierId ? list.find(r => r.suppliers_id == supplierId) : list.find(r => r.default) || list[0]
            if(match) {
              var cost = parseFloat(match.price_cost || match.price_list || 0)
              if(cost) this.$set(item, 'price_cost', cost)
              this.$set(item, '_supplierNotLinked', false)
            } else if(supplierId) {
              this.$set(item, '_supplierNotLinked', true)
            }
          })
          .catch(() => {})
      },
      syncDetailRegisterPurchasePriceDefaults() {
        if(!this.allowPurchasePricing) return
        var sp = this.getDetailRegisterSupplierProduct
        if(!this.crud.form.detail_register.button.editing) {
          var supplierId = this.operation ? (this.operation.suppliers_id || 0) : 0
          if(sp && supplierId && sp.suppliers_id && sp.suppliers_id != supplierId) {
            sp = null
          }
          this.crud.form.detail_register.price_cost = sp ? parseFloat(sp.price_list || sp.price_cost || 0) : 0
        }
      },
      formatCurrency(value) {
        return Intl.NumberFormat('es-AR',{style:'currency',currency:this.currency}).format(parseFloat(value || 0))
      },
      toNumber(value) {
        var n = parseFloat(value)
        return isNaN(n) ? 0 : n
      },            
    }
  }
</script>
<style>
  .crud-order-table-detail {
    overflow: auto;
    max-height: 350px;    
    min-height: 100px;    
  }
  .block-product-add {
    background: white;
    filter: brightness(0.4);
    border-radius: 15px;
    padding-top: 10px;
    pointer-events: none;
    opacity: 0.5;
  }
  .crud-new-orders-button-add {
    margin-top: 29px;
  }  
  .p79-alert {
    font-size: 12px;
    padding: 8px 12px;
    border-radius: 4px;
  }
  .block-product-add-div {
    position: absolute;
    text-align: center;
    margin-top: 20px;    
  }  
</style>
